// extracted by mini-css-extract-plugin
export default {"wrapper":"FavoriteDate_wrapper__+f93b","date":"FavoriteDate_date__7K+ZD","date-month":"FavoriteDate_date-month__iBslH"};